import { dateLocalizationConfig, parseLocalizedDate } from '@lotta/shared/util-locale';
import { DateTime } from 'luxon';

// Fallback to ISO format if locale config is missing
const fallback = {
  order: 'YMD',
  format: 'yyyy-LL-dd',
  placeholder: 'YYYY-MM-DD',
};

const getConfig = (locale: string) => {
  const [lc, cc] = locale.split('-');
  return dateLocalizationConfig?.[cc]?.[lc] ?? fallback;
};

export const toIsoDate = (date: string, locale: string) => {
  const { order } = getConfig(locale);
  return parseLocalizedDate(date, order);
};

export const toLocalizedDate = (date: string, locale: string) => {
  if (date.length !== 10) {
    return null;
  }
  const { format } = getConfig(locale);
  const datetime = DateTime.fromISO(date);
  return datetime.isValid ? datetime.toFormat(format) : null;
};

export const getPlaceholder = (locale: string) => getConfig(locale)?.placeholder ?? '';
